export default __webpack_public_path__ + "static/media/user-generated-funds.6e2ce11e.png";